module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAS9JREFUOE+tk79Kw1AUxr/vRlBnEReH3MmxgrOYdnOzKfoGtuKmL9LJf/ENFKubW9LirOimUzO4FB9AhSRHkijGNKYQerdzzzk/zr+PyD3dvKuBYRtEA4D57fYhcCGGM7xef8qm8McwLW8OC6oLSJuAyoNjW4AIoBOo0eHr5c57/JcAlrcv5mfCpVtSNooS838iHATGaDOGJADT9k5JdvKBwysr8etWX8Yhcub36nvUTbcmynggZKzsUgAYIYzWqO3BESj7RaWXAZJ44TF1y3sGuFIJAHmhtvsfIGYrAQSfUwCUtDB5pUkL/w9xEkAEJzS3vFUY6r7yGqsfEhy/Z3Wmc8q/eljsgmq3qJ1UTIwg0XlgvB38EVN2WOlMYkWyAWEqZ4ovoItQHP+m/piN/wJJ3KHMcqomXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tip.png
// module id = 12
// module chunks = 0